// export const RZP_KEY = "rzp_live_2OnREDu2NLgInj";
export const RZP_KEY = 'rzp_live_2OnREDu2NLgInj';
